export const CLINICAL_DOCTOR_ROLES = ['DOCTOR', 'RMO', 'DOCTOR_TEAM_LEAD'] as const;

export function isClinicalDoctorRole(role?: string | null): boolean {
  return role === 'DOCTOR' || role === 'RMO' || role === 'DOCTOR_TEAM_LEAD';
}

export function isRmoRole(role?: string | null): boolean {
  return role === 'RMO';
}

/** Roles allowed on /doctor/* routes and doctor dashboard redirects. */
export const DOCTOR_PORTAL_ROLES = CLINICAL_DOCTOR_ROLES;

export const DOCTOR_PORTAL_ROLE_LIST: string[] = [...DOCTOR_PORTAL_ROLES];

export function needsDoctorProfileFields(role?: string | null): boolean {
  return isClinicalDoctorRole(role);
}
